import React, { useEffect, useState } from 'react'
import CanaisLista from './CanaisLista.jsx'
 
import CompActive from './CompActive.jsx'  

import { data_live } from '../api/datalive'

 const categoryConfig = [
  { title: "Ao Vivo", apiCall:  async ( ) => await data_live.mostrarcanais( "Ao Vivo") , Component: CanaisLista, propName: "canaislist", isFunction: true },
  { title: "Teatro", apiCall:  async ( ) => await data_live.mostrarcanais( "Teatro") , Component: CanaisLista, propName: "canaislist", isFunction: true },
  { title: "Música", apiCall:  async ( ) => await data_live.mostrarcanais( "Música") , Component: CanaisLista, propName: "canaislist", isFunction: true },
  { title: "Shows", apiCall:  async ( ) => await data_live.mostrarcanais( "Shows") , Component: CanaisLista, propName: "canaislist", isFunction: true },
  
]

function CategoriaLista() {
  const [isloading, setIsLoading] = useState(true)
  const [categoryData, setCategoryData] = useState([])

  useEffect(() => {
    _carregatela()
  }, [])

  const _carregatela = async () => {
    setIsLoading(true)
    const promises = categoryConfig.map(async (category) => {
      const response = await (category.isFunction ? category.apiCall() : category.apiCall)
      return {
        ...category,
        data: response ? (category.isFunction ? response  : response.data.data) : [],
      }
    })

    const results = await Promise.all(promises)
    setCategoryData(results.filter(cat => cat.data && cat.data.length > 0))
    setIsLoading(false)
  }

  if (isloading) {
    return (
      <div className="flex justify-center py-8">
        <div className="w-12 h-12">
          <CompActive />
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-10 md:space-y-16">
      {categoryData.map((category, index) => {
        if (category.data && category.data.length > 0) {
          const { Component, propName } = category
          return (
            <section key={index} className='space-y-4'>
              <h2 className='text-2xl md:text-3xl font-display font-bold text-text-subtle hover:text-text transition-colors duration-300'>
                {category.title}
              </h2>
              <Component {...{ [propName]: category.data }} />
            </section>
          )
        }
        return null
      })}
    </div>
  )
}

export default CategoriaLista